import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Icons_UI_Checkbox_Check-Box_ON",
	"data-name": "Icons & UI/Checkbox/Check-Box_ON",
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		id: "bkg",
		width: 27,
		height: 27,
		rx: 2,
		transform: "translate(4.5 4.5)",
		fill: "#4664fb"
	}), /* @__PURE__ */ _jsx("path", {
		id: "checkmark",
		d: "M13.26,1.512,11.981.239A.84.84,0,0,0,11.391,0a.871.871,0,0,0-.6.242L4.641,6.37,2.705,4.443a.869.869,0,0,0-.6-.242.84.84,0,0,0-.591.239L.24,5.713A.832.832,0,0,0,0,6.3a.863.863,0,0,0,.243.593l3.8,3.783a.846.846,0,0,0,.6.244.855.855,0,0,0,.6-.245l8.019-7.983A.863.863,0,0,0,13.5,2.1a.834.834,0,0,0-.24-.588",
		transform: "translate(11.25 12.75)",
		fill: "#fff"
	})]
});
export { SvgCheckboxChecked as ReactComponent };
